module.exports = __webpack_public_path__ + "img/charges.2470cd8d.png";